// DayPasses reducer

import { initializeState } from '../../../utilities/storageUtils';
import dayPassActionTypes from './dayPasses.types';

const INITIAL_STATE = {
  numberOfGuests: 0,
  arrivalDate: null,
  selectedTitle: '',
  selectedRate: 0,
  selectedRateCode: '',
  selectedItemCode: '',
  selectedDescription: '',
  availabilityKey: null,
  promoCode: '',
  qualifyingId: '',
  item: {
    rate: '',
    itemCode: '',
    rateCode: ''
  },
  parkingFee: 0,
  resortFee: 0,
  sustainabilityFee: 0,
  taxesAndFees: 0
};

const dayPassesReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case dayPassActionTypes.SET_DAYPASSES:
      return {
        ...state,
        availabilityKey: action.availabilityKey,
        arrivalDate: action.arrivalDate,
        numberOfGuests: action.numberOfGuests,
        selectedTitle: action.selectedTitle,
        selectedRate: action.selectedRate,
        selectedItemCode: action.selectedItemCode,
        selectedRateCode: action.selectedRateCode,
        promoCode: action.promoCode,
        qualifyingId: action.qualifyingId,
        selectedDescription: action.selectedDescription,
        parkingFee: action.parkingFee,
        resortFee: action.resortFee,
        sustainabilityFee: action.sustainabilityFee,
        taxesAndFees: action.totalTaxesAndFees,
        item: [action.item]
      };

    default:
  }

  return state;
};

export default dayPassesReducer;
